import CollapseButton from "../components/CollapseButton";
import CollapseElement from "../components/CollapseElement";
import { useLoaderData } from "react-router-dom";

function NounExplanationPage() {
  let displaySmallText;
  if (window.innerWidth < 700) {
    displaySmallText = true;
  } else {
    displaySmallText = false;
  }
  const data = useLoaderData();

  const values = [
    {
      id: "generalRules",
      lgBtnTitle: "Rialacha Ginearálta",
      smBtnTitle: "Rialacha Gin.",
      displayOnLoad: true,
      content: { __html: data.generalRules },
    },
    {
      id: "female",
      lgBtnTitle: "Baininscneach",
      smBtnTitle: "Bain.",
      displayOnLoad: false,
      content: { __html: data.feminineRules },
    },
    {
      id: "male",
      lgBtnTitle: "Firinscneach",
      smBtnTitle: "Firin.",
      displayOnLoad: false,
      content: { __html: data.masculineRules },
    },
  ];

  return (
    <div className="grammar-explanation-page-container">
      <div className="row-1-with-3-buttons">
        {values.map((elm) => {
          return (
            <CollapseButton
              key={elm.id}
              id={elm.id}
              title={displaySmallText ? elm.smBtnTitle : elm.lgBtnTitle}
              displayOnLoad={elm.displayOnLoad}
            />
          );
        })}
      </div>

      <div className="nes-container is-rounded row-2">
        {values.map((elm) => {
          return (
            <CollapseElement
              key={elm.id}
              id={elm.id}
              content={elm.content}
              displayOnLoad={elm.displayOnLoad}
            />
          );
        })}
      </div>
    </div>
  );
}

export default NounExplanationPage;
